import css from 'styled-jsx/css';

const styles = css`ul{list-style-type:none;margin:0;padding:0 0 1rem}@media (max-width:767px){margin-top:1em}li{display:inline}ul>li+li{margin-left:.3em}ul>li+li:before{color:#3e454d;content:"/ "}`;

export default styles;